import { Accordion, AccordionDetails, AccordionSummary } from '@tunasong/ui-lib'
import { ExpandMore } from '@tunasong/icons'
import React from 'react'
import type { FC } from 'react'

export interface CollapsableProps {
  title?: string
  defaultExpanded?: boolean
  children: React.ReactNode
}

export const Collapsable: FC<CollapsableProps> = ({ title, defaultExpanded = true, children }) => (
  <Accordion defaultExpanded={defaultExpanded}>
    <AccordionSummary expandIcon={<ExpandMore />}>{title}</AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
)

export default Collapsable
